import { times } from 'lodash'

import type { StylableElementProps } from '../DefaultElementProps'
import { Fill } from './Fill'
import { Line } from './Line'

const lineLengths = [1, 0.5, 0.8, 0.7]

type Props = StylableElementProps & {
	lines?: number
	width?: number | string
}

export const PlaceholderInternal = ({ lines = 1, width = '80%', className, style }: Props) => {
	const widthString = typeof width === 'number' ? `${width}px` : width

	return (
		<>
			{times(lines, (idx) => {
				const factor = lineLengths[idx % lineLengths.length]
				return (
					<Line key={idx} className={className} style={style}>
						&#8203;
						<Fill width={factor === 1 ? widthString : `calc(${widthString} * ${factor})`} />
					</Line>
				)
			})}
		</>
	)
}
